import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import PlanBodyFiller from './PlanBodyFiller';
import { reachMetrikaGoal } from '../../../services/MetrikaService';
import { getEncGitHubToken } from '../../../services/mini/gitHubToken';
import ConnectGithubAccountForm from '../../containers/ConnectGithubAccountForm';
import GitHubPromoPlanControls from './GitHubPromoPlanControls';
import { checkForGitHubPromoPlan } from '../../../services/mini/checkForGitHubPromoPlan';


function PlanTile({
    plan,
    currentPlanId,
    onChangePlan,
    onContactSales,
    plansCount,
    hidePlanBtn,
    numOfStars,
    githubLogin,
    inPlans
}) {
    const isCurrent = currentPlanId === plan.id;
    const isRecommended = function () {
        if (!plan.rules) {
            return false;
        }
        try {
            return JSON.parse(plan.rules).recommended;
        } catch (e) {
            console.error(`Invalid plan rules: ${JSON.stringify(plan)}`);
            return false;
        }
    }();

    const isContactSalesButton = function () {
        if (!plan.rules) {
            return false;
        }
        try {
            return JSON.parse(plan.rules).contactSalesButton;
        } catch (e) {
            console.error(`Invalid plan rules: ${JSON.stringify(plan)}`);
            return false;
        }
    }();

    const isGithubPromoPlan = checkForGitHubPromoPlan(plan);

    const changePlanCb = useCallback(() => {
        if (onChangePlan && !isCurrent) {
            reachMetrikaGoal('onChangePlanClick');
            onChangePlan(plan);
        }
    }, [onChangePlan, plan, isCurrent]);

    const withLogo = plan.websiteDescription?.indexOf('plan-logo') > 0;
    const isExternalPayment = plan.isExternalPayment;
    const githubConnected = githubLogin && getEncGitHubToken();

    return <div
        className={`plan-tile ${isCurrent && 'current'} ${withLogo && 'with-logo'} ${isExternalPayment && 'no-price'} ${isRecommended && 'recommended'} ${inPlans && 'in-plans'} ${!onChangePlan && 'default-cursor'} ${plansCount === 1 && 'only-one-plan'} ${(isGithubPromoPlan && (hidePlanBtn !== true && !isCurrent)) ? 'github-promo' : ''}`}>
        <div className="plan-tile_info">
            <PlanBodyFiller plan={plan} />
        </div>
        {hidePlanBtn !== true &&
            <React.Fragment>
                {isCurrent ?
                    <div className="plan-tile_btn-holder">
                        <div className="plan-tile_btn disabled-without-opacity">
                            Current
                        </div>
                    </div> :

                    <div className="plan-tile_btn-holder" onClick={isContactSalesButton ? undefined : changePlanCb}>
                        {!isContactSalesButton ?
                            <div className={`plan-tile_btn ${isContactSalesButton && 'recommended'}`}>
                                Change plan
                            </div> :
                            <a
                                onClick={onContactSales}
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://share.hsforms.com/1hfEwdLMuRmqEBmL5szPP6w3xfz0"
                                className="plan-tile_btn">
                                Contact Sales
                            </a>}
                    </div>
                }
            </React.Fragment>}

    </div>;
}


function mapStateToProps({ user }, ownProps) {
    return {
        githubLogin: user.githubLogin,
        numOfStars: user.numOfStars,
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanTile);